import { Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import React, { useEffect, useCallback } from 'react';
import previewSelector from '../../../utils/previewSelector';
import { Link } from '@mui/icons-material';
import fileSize from 'filesize';
import { IAttachment } from '../../../models/iequipment';

interface IProps {
  attachment: IAttachment;
}

const FileList = ({ attachment }: IProps) => {
  return (
    <Box sx={{ padding: '10px' }}>
      <Box sx={{ fontWeight: 'bold' }}>{attachment.description}</Box>
      <List dense={true} sx={{ marginLeft: 1 }}>
        {attachment.files.map((file, index) => (
          <div key={file._id} style={{ display: 'flex', flexDirection: 'row' }}>
            <ListItem style={{ paddingLeft: 0 }}>
              <ListItemAvatar>
                <img style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '5px'
                }} src={previewSelector(file)} />
              </ListItemAvatar>
              <ListItemText
                primary={<Typography style={{ fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', width: '13rem' }}>{file.name}</Typography>}
                secondary={<Typography style={{ fontSize: 12, color: 'grey' }}>{file.size ? fileSize(file.size) : 0}</Typography>}
              />
            </ListItem>
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <IconButton size="large" color="primary"><Link /></IconButton>
            </a>
          </div>
        ))}
      </List>
    </Box>

  )
}
export default FileList;

